export default __webpack_public_path__ + "static/media/ride5.3c66c83d.png";